import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';
import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
import * as XLSX from "xlsx"; // Import XLSX for Excel export

const TransactionHistory = () => {

    const [transactions, setTransactions] = useState([]);
    const [phoneFilter, setPhoneFilter] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [manualForm, setManualForm] = useState({
        name: '',
        phone: '',
        txid: '',
        type: '',
        title: '',
        subtitle: '',
        price: '',
        discount: '',
        startDate: '',
        expiryDate: ''
    });


    useEffect(() => {
        db.collection('nv_transaction_history')
            .orderBy('createdAt', 'desc')
            .get()
            .then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data());
                setTransactions(data);
            })
            .catch(err => {
                console.error('Error fetching transaction history:', err);
            });
    }, []);

    const exportToExcel = () => {
        const formattedData = [];

        // Filtered transactions based on phone filter
        const filtered = transactions.filter(item =>
            phoneFilter === '' || item.phone.toLowerCase().includes(phoneFilter.toLowerCase())
        );

        // Build formatted data rows
        filtered.forEach((item) => {
            formattedData.push({
                "Name": item.name,
                "Phone No": item.phone,
                "TXN ID": item.txid,
                "Type": item.type,
                "Title": item.title,
                "Subtitle": item.subtitle,
                "Price": item.price,
                "Discount": item.discount,
                "Start Date": item.startDate?.toDate().toLocaleDateString(),
                "Expiry Date": item.expiryDate?.toDate().toLocaleDateString(),
                "Created At": item.createdAt?.toDate().toLocaleString()
            });
        });

        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Transactions");
        XLSX.writeFile(wb, "Transaction_History.xlsx");
    };


    const handleManualChange = (e) => {
        const { name, value } = e.target;
        setManualForm(prev => ({ ...prev, [name]: value }));
    };

    // const handleManualSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const data = {
    //             ...manualForm,
    //             createdAt: Timestamp.now(),
    //             startDate: manualForm.startDate ? Timestamp.fromDate(new Date(manualForm.startDate)) : null,
    //             expiryDate: manualForm.expiryDate ? Timestamp.fromDate(new Date(manualForm.expiryDate)) : null,
    //             price: `₹${manualForm.price}`,
    //             discount: `${manualForm.discount}`
    //         };

    //         await addDoc(collection(db, "nv_transaction_history"), data);

    //         setTransactions(prev => [data, ...prev]);
    //         Swal.fire("Success", "Transaction added manually!", "success");
    //         setShowModal(false);
    //         setManualForm({
    //             name: '',
    //             phone: '',
    //             txid: '',
    //             type: '',
    //             title: '',
    //             subtitle: '',
    //             price: '',
    //             discount: '',
    //             startDate: '',
    //             expiryDate: ''
    //         });
    //         closeModel();
    //     } catch (err) {
    //         console.error("Manual entry error:", err);
    //         Swal.fire("Error", "Failed to save transaction", "error");
    //     }
    // };
    // const handleManualSubmit = async (e) => {
    //     e.preventDefault();
    //     console.log("Selected Type:", manualForm.type);
    //     console.log("Selected:", manualForm);
    //     try {
    //         console.log("Selected Type:", manualForm.type); // 👈 Console log here

    //         const data = {
    //             ...manualForm,
    //             createdAt: Timestamp.now(),
    //             startDate: manualForm.startDate ? Timestamp.fromDate(new Date(manualForm.startDate)) : null,
    //             expiryDate: manualForm.expiryDate ? Timestamp.fromDate(new Date(manualForm.expiryDate)) : null,
    //             price: manualForm.price ? `₹${manualForm.price}` : "₹0",
    //             discount: manualForm.discount ? `${manualForm.discount}` : "0",
    //             entry: "manual"
    //         };

    //         await addDoc(collection(db, "nv_transaction_history"), data);

    //         setTransactions((prev) => [data, ...prev]);
    //         Swal.fire("✅ Success", "Manual transaction has been added successfully.", "success");

    //         setManualForm({
    //             name: '',
    //             phone: '',
    //             txid: '',
    //             type: '',
    //             title: '',
    //             subtitle: '',
    //             price: '',
    //             discount: '',
    //             startDate: '',
    //             expiryDate: ''
    //         });

    //         setShowModal(false);
    //         closeModel();
    //     } catch (err) {
    //         console.error("Manual entry error:", err);
    //         Swal.fire("❌ Error", "Failed to save transaction. Please try again.", "error");
    //     }
    // };


    const updateMembershipByPhone = async (phone_no, updatedData) => {
        try {
            const docRef = doc(db, "nv_glow_membership", phone_no);
            await updateDoc(docRef, updatedData);
            console.log(`✅ Membership for ${phone_no} updated.`);
        } catch (err) {
            console.error(`❌ Failed to update membership for ${phone_no}:`, err);
        }
    };

    const handleManualSubmit = async (e) => {
        e.preventDefault();
        console.log("Selected Type:", manualForm.type);

        try {
            const data = {
                ...manualForm,
                createdAt: Timestamp.now(),
                startDate: manualForm.startDate ? Timestamp.fromDate(new Date(manualForm.startDate)) : null,
                expiryDate: manualForm.expiryDate ? Timestamp.fromDate(new Date(manualForm.expiryDate)) : null,
                price: manualForm.price ? `₹${manualForm.price}` : "₹0",
                discount: manualForm.discount ? `${manualForm.discount}` : "0",
                entry: "manual"
            };

            await addDoc(collection(db, "nv_transaction_history"), data);

            // ✅ Update membership if type is Glow
            if (manualForm.type.toLowerCase() === "membership") {
                const updatedMembership = {
                    created_date: Timestamp.now(),
                    start_date: manualForm.startDate ? Timestamp.fromDate(new Date(manualForm.startDate)) : null,
                    end_date: manualForm.expiryDate ? Timestamp.fromDate(new Date(manualForm.expiryDate)) : null,
                    membership_type: "Glow",
                    phone_no: manualForm.phone,
                    price: `${manualForm.price} for 1 Month`,
                    status: "1"
                };
                await updateMembershipByPhone(manualForm.phone, updatedMembership);
            }

            setTransactions(prev => [data, ...prev]);
            Swal.fire("✅ Success", "Manual transaction has been added successfully.", "success");

            setManualForm({
                name: '',
                phone: '',
                txid: '',
                type: '',
                title: '',
                subtitle: '',
                price: '',
                discount: '',
                startDate: '',
                expiryDate: ''
            });

            setShowModal(false);
            closeModel();

        } catch (err) {
            console.error("Manual entry error:", err);
            Swal.fire("❌ Error", "Failed to save transaction. Please try again.", "error");
        }
    };



    const closeModel = () => {
        window.openModelNew();
    }


    return (
        <>
            <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>
            <div className="mb-3 d-flex align-items-center gap-3">


            </div>
            <div className="p-3">
                <div className="card-header pb-0 px-3" style={{ display: "flex" }}>
                    <h4 className="mb-2 mr-4">Orders List</h4>

                    <Form.Control
                        type="text"
                        placeholder="Search by Phone Number..."
                        value={phoneFilter}
                        onChange={(e) => setPhoneFilter(e.target.value)}
                        style={{ width: "300px" }}
                    />

                    <div className="ml-4 d-flex gap-3">
                        <Button variant="success" onClick={exportToExcel}>
                            Download Excel
                        </Button>
                        <button class="btn btn-info" data-toggle="modal" data-target="#manualTransactionModal">➕ Manual Transaction</button>
                    </div>

                </div>
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Type</th>
                                <th>Title</th>
                                <th>Amount</th>
                                <th>TXN ID</th>
                                <th>Start Date/Purchase Date</th>
                                <th>Expiry</th>
                                <th>Entry</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactions
                                .filter(item =>
                                    phoneFilter === '' || item.phone.toLowerCase().includes(phoneFilter.toLowerCase())
                                )
                                .map((item, idx) => (
                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                        <td >{idx + 1}</td>
                                        <td >{item.name}</td>
                                        <td >{item.phone}</td>
                                        <td >{item.type}</td>
                                        <td >{item.title}</td>
                                        <td >{item.price}</td>
                                        <td >{item.txid}</td>
                                        <td >{item.startDate?.toDate().toLocaleDateString()} {item.purchaseDate?.toDate().toLocaleDateString()}</td>
                                        <td >{item.expiryDate?.toDate().toLocaleDateString()}</td>
                                        <td >{item.entry}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>


            </div>

            <div className="col-md-12">
                <div
                    className="modal fade"
                    id="manualTransactionModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="modal-form"
                    aria-hidden="true"
                    data-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <form onSubmit={handleManualSubmit}>
                                    <div className="" style={{ textAlign: "center" }}>
                                        <span style={{ color: "black", fontSize: "25px", fontWeight: "700", textTransform: "uppercase" }}>
                                            Manual Transaction Entry
                                        </span>
                                    </div>

                                    <div className="row mt-3">
                                        {[
                                            { label: "Name", name: "name" },
                                            { label: "Phone", name: "phone" },
                                            { label: "TXN ID", name: "txid" },
                                            { label: "Title", name: "title" },
                                            { label: "Subtitle", name: "subtitle" },
                                            { label: "Price", name: "price", type: "number" },
                                            { label: "Discount", name: "discount", type: "number" },
                                            { label: "Start Date", name: "startDate", type: "date" },
                                            { label: "Expiry Date", name: "expiryDate", type: "date" },
                                        ].map((field, i) => (
                                            <div className="col-md-4 mb-3" key={i}>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    style={{
                                                        height: "45px",
                                                        padding: "12px 20px",
                                                        border: "2px solid #ccc",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#f8f8f8",
                                                        fontSize: "16px",
                                                    }}
                                                    placeholder={field.label}
                                                    name={field.name}
                                                    value={manualForm[field.name] || ''}
                                                    onChange={handleManualChange}
                                                    required={field.name !== "subtitle"}
                                                />
                                            </div>
                                        ))}

                                        {/* Dropdown for Type */}
                                        <div className="col-md-4 mb-3">
                                            <select
                                                className="form-control"
                                                style={{
                                                    // height: "45px",
                                                    // padding: "12px 20px",
                                                    border: "2px solid #ccc",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f8f8f8",
                                                    fontSize: "16px",
                                                }}
                                                name="type"
                                                value={manualForm.type || ""}
                                                onChange={handleManualChange}
                                                required
                                            >
                                                <option value="">Select Type</option>
                                                <option value="membership">Membership</option>
                                                <option value="course">Course</option>
                                                <option value="grow">Grow</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="modal-footer mt-3">
                                        <a class="btn bg-gradient-info btn-sm mb-0" style={{ color: "white" }} onClick={closeModel}>Close</a>
                                        <button type="submit" className="btn bg-gradient-success btn-sm mb-0" style={{ color: "white" }}>
                                            Save Entry
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default TransactionHistory;
